import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React, { useEffect, useMemo, useState } from 'react';
import { IntlProvider } from 'react-intl-next';
import { normalizeLocale, DEFAULT_LOCALE } from '../i18n/locale';
export var I18nProvider = function I18nProvider(_ref) {
  var children = _ref.children,
    _ref$locale = _ref.locale,
    incomingLocale = _ref$locale === void 0 ? DEFAULT_LOCALE : _ref$locale,
    fetchTranslations = _ref.fetchTranslations;
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    messages = _useState2[0],
    setMessages = _useState2[1];
  var locale = useMemo(function () {
    return normalizeLocale(incomingLocale);
  }, [incomingLocale]);
  useEffect(function () {
    var loadTranslations = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var localeMessages;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return fetchTranslations(locale);
            case 2:
              localeMessages = _context.sent;
              setMessages(localeMessages);
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function loadTranslations() {
        return _ref2.apply(this, arguments);
      };
    }();
    void loadTranslations();
  }, [fetchTranslations, locale]);
  if (!messages) {
    return null;
  }

  // Do not place formatMessage / FormattedMessage / useIntl calls here outside of the I18nProvider.
  // They will not function correctly due to a lack of I18n context.

  return /*#__PURE__*/React.createElement(IntlProvider, {
    locale: locale,
    messages: messages,
    defaultLocale: DEFAULT_LOCALE
  }, children);
};